<template>
  <Hero :title="data?.title"/>
  <main class="main maxw--waist">
    <div class="block text--center">
      <span class="event__date">{{ dateDisplay }}</span>
    </div>
    <div class="block maxw--waist text--center" v-html="$md.render(data?.content || '')"></div>
    <div class="block maxw--neck" v-if="data?.poster?.data">
      <nuxt-img v-if="data?.poster" provider="strapi" :src="getStrapiImageLocation(data?.poster)" class="fit"/>
    </div>

    <div class="block maxw--waist" v-if="data?.allow_responses">
      <h2 class="text--center mb-1">Ben je aanwezig?</h2>
      <template v-if="!isBefore(startDate, new Date())">
        <p class="text--center">
          <i>Om je aanwezigheid aan te geven, vul onderstaand formulier in:</i>
        </p>
        <EventResponseForm :event="data"/>
      </template>
      <template v-else>
        <p class="text--center">
          <i>Het is helaas niet meer mogelijk om in te schrijven voor dit evenement.</i>
        </p>
      </template>
    </div>
  </main>
</template>

<script lang="ts" setup>
import Event from "~/typings/event";
import { isSameDay, format, isBefore } from 'date-fns'

const route = useRoute();
const { findOne } = useStrapi();

const { data, pending } = await useAsyncData(
  'eventpage',
  () => findOne<Event>('slugify/slugs/event/' + route.params.slug, { populate: ['poster'] }),
  {
    transform: flattenStrapiObject
  }
);

if (!data.value && !pending.value) {
  throw createError({ statusCode: 404, statusMessage: 'Evenement niet gevonden' });
}

useHead({
  title: `Album: ${data.value?.title || ''}`
});

useHead({
  title: `Evenement: ${data.value?.title}`
});

const startDate = computed(() => new Date(data.value?.start || ''));
const endDate = computed(() => new Date(data.value?.end || ''));

const dateDisplay = computed(() => {
  if (isSameDay(startDate.value, endDate.value)) {
    let str = format(startDate.value, 'd MMMM yyyy');

    if (data.value?.full_day) {
      // Full day so no time needed
      return str;
    }

    return `${str} | ${format(startDate.value, 'HH:mm')} - ${format(endDate.value, 'HH:mm')}`;
  }

  if (data.value?.full_day) {
    return `${format(startDate.value, 'd MMMM yyyy')} - ${format(endDate.value, 'd MMMM yyyy')}`;
  }

  return `${format(startDate.value, 'd MMMM yyyy HH:mm')} - ${format(endDate.value, 'd MMMM yyyy HH:mm')}`;
})

</script>

<style lang="scss">
.event__date {
  font-size: 1.5rem;
  font-weight: 500;
}
</style>
